import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NotificationsService } from '../../../../../services/notifications.service';
import { NotificationsListService } from '../../notifications-list.service';
import { PagesMapService } from '../../../../pages.map';
import { Notification } from '../../../../../modals/notification';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-notifications-table',
  templateUrl: './notifications-table.component.html',
  styleUrls: ['./notifications-table.component.scss'],
  standalone: false,
})
export class NotificationsTableComponent implements OnInit {
  @Input() notifications;
  @Input() filter;

  constructor(
    private notificationsService: NotificationsService,
    private notificationsListService: NotificationsListService,
    private pagesMapService: PagesMapService
  ) {}

  ngOnInit() {}

  public onChangeNotificationStatus(notification: Notification): void {
    notification.isChangeStatus = true;
    this.notificationsService
      .changeNotificationStatus({
        status: +!notification.status,
        notification_id: notification.id,
        last_visible_notification_id: null,
      })
      .subscribe(
        (response) => {
          notification.status = +!notification.status;
          this.notificationsListService.updateNotifications(this.notifications);
          notification.isChangeStatus = false;
        },
        () => {
          notification.isChangeStatus = false;
        }
      );
  }
}
